import { apiService } from "@/core/services";

export let listApiService = {
  getPublicHybrid,
  getAvailabilityZone,
  getRegion,
};

async function getPublicHybrid(data) {
  let list = [];
  let result = null;
  let requestOptions = {
    //API Fillter Request Below
    params: {
      folderId: data.folderId,
    },
  };
  await apiService()
    .get(`/ali/resource-folders`, requestOptions)
    .then((response) => {
      result = response.data;
      result.map((x) => {
        list.push({
          text: x.label,
          value: { name: x.label, value: x.value },
        });
      });
    });
  return list;
}
function getAvailabilityZone(val) {
  let list = [];
  let result = null;
  let requestOptions = {
    //API Fillter Request Below
    params: {
      region: val,
    },
  };
  apiService()
    .get(`/aliyun/availability_zones/get`, requestOptions)
    .then((response) => {
      result = response.data;
      result.map((x) => {
        list.push(x);
      });
    });
  return list;
}
function getRegion(val) {
  let list = [];
  let result = null;
  let requestOptions = {
    //API Fillter Request Below
    params: {
      region: val,
    },
  };
  apiService()
    .get(`/aliyun/regions/get`, requestOptions)
    .then((response) => {
      result = response.data;
      result.map((x) => {
        list.push(x.availability_zone);
      });
    });
  return list;
}
